import React from "react";
import styled from "@emotion/styled";
import { Tooltip } from "../../Tooltip";
import classnames from "classnames";
import { ChecklistItem, User } from "@ecologi/shared";
import { Typography } from "../../Typography";

import styles from "../styles/ProfileChecklistItem.module.scss";

//required to style the Typography component
const ListItemText = styled(Typography)<{ isComplete?: boolean }>`
  color: ${(props) =>
    props.isComplete
      ? props.theme.colors.snowdrop
      : props.theme.colors.charcoal};
`;

export type ProfileChecklistItemHandlers = {
  onToggleChecklistItem: (user: User, item: ChecklistItem) => Promise<void>;
  onRemoveChecklistItem: (user: User, item: ChecklistItem) => Promise<void>;
};

type Props = {
  isOwnProfile: boolean;
  item: ChecklistItem;
  user: User;
} & ProfileChecklistItemHandlers;

export const ProfileChecklistItem = (props: Props) => {
  const { isOwnProfile, item, user } = props;

  const cls = classnames(styles.profileChecklistItem, {
    [styles.profileChecklistItemComplete]: item.isComplete,
  });

  return (
    <li className={cls}>
      <Tooltip
        content={item.isComplete ? "Mark as incomplete" : "Mark as complete"}
      >
        <button
          aria-label={item.text}
          role="radio"
          aria-checked={item.isComplete}
          className={styles.profileChecklistItemButton}
          disabled={!isOwnProfile}
          type="button"
          onClick={async (e) => {
            e.preventDefault();
            e.currentTarget.blur();
            // await toggleChecklistItem(user, item);
            props.onToggleChecklistItem(user, item);
          }}
        />
      </Tooltip>
      <ListItemText use="body1" as="p" isComplete={item.isComplete}>
        {item.text}
      </ListItemText>
      {isOwnProfile && (
        <Tooltip content="Delete goal">
          <button
            aria-label={"delete-" + item.text}
            className={styles.profileChecklistItemDeleteButton}
            disabled={!isOwnProfile}
            type="button"
            onClick={async (e) => {
              e.preventDefault();
              e.currentTarget.blur();
              props.onRemoveChecklistItem(user, item);
            }}
          />
        </Tooltip>
      )}
    </li>
  );
};
